module.exports = __webpack_public_path__ + "img/handshake-simple.1eeef4d1.svg";